// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorIndicator_wrapper__4-QX2","indicator":"ColorIndicator_indicator__bxUDc","danger":"ColorIndicator_danger__41Mby","info":"ColorIndicator_info__RAgxO"};